
export function sorted(arr) {
    return [...(arr||[])].sort();
}

export function binarySearch(haystack, needle) {
    let start = 0;
    let end = haystack.length - 1;
    while (start <= end) {
        const mid = start + ((end - start) / 2 | 0);
        const elem = haystack[mid];
        if (elem > needle) {
            end = mid - 1;
        } else if (elem < needle) {
            start = mid + 1;
        } else {
            return mid;
        }
    }
    return -1;
}
